import './text-image.scss';
import 'slick-carousel';
import 'magnific-popup';
export default () => {
  $('.js-image-slider').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false
  });
  $('.popup-youtube').magnificPopup({
    type: 'iframe'
  });
  $('.pauseplayButton').on('click', function () {
    if ($(this).hasClass('paused')) {
      $('.js-image-slider').slick('slickPause');
      $(this).html('Afspelen');
      $(this).removeClass('paused');
      $(this).addClass('playing');
      $(this).prev().html('Diavoorstelling gestopt');
    } else {
      $('.js-image-slider').slick('slickPlay');
      $(this).html('Pauzeren');
      $(this).removeClass('playing');
      $(this).addClass('paused');
      $(this).prev().html('Diavoorstelling afspelen');
    }
  });
};